import { Injector } from "@angular/core";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
}   
)
export class MasterGuard implements CanActivate, CanActivateChild{
    constructor(private injector: Injector){

    }

    async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        console.log("MasterGuard -> CanActivateChild")
        let guards = childRoute.data.guards || [];
        //let guards = childRoute.data.guards || [];
        for (let guard of guards){
            let instance: CanActivateChild = this.injector.get(guard);
            let result = await instance.canActivateChild(childRoute, state);
            if (result instanceof Observable){
                result = await result.toPromise();
            }
            if (result ==false || result instanceof UrlTree){
                return result;
            }
        }
        return true;
    }
    
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Promise<boolean | UrlTree> {
        console.log("MasterGuard -> CanActivate")
        let guards = route.data.guards || [];
        for (let guard of guards){
            let instance: CanActivate = this.injector.get(guard);
            let result = await instance.canActivate(route, state);
            if (result instanceof Observable){
                result = await result.toPromise();
            }
            if (result ==false || result instanceof UrlTree){
                return result;
            }
            
        }
        return true;
    }
}